import { render, staticRenderFns } from "./CSpinner.vue?vue&type=template&id=376bc9c0&scoped=true&"
import script from "./CSpinner.vue?vue&type=script&lang=ts&"
export * from "./CSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./CSpinner.vue?vue&type=style&index=0&id=376bc9c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376bc9c0",
  null
  
)

export default component.exports